import { connectRouter } from "connected-react-router";
import { History } from "history";
import { combineReducers } from "redux";

import { IStoreState } from "interfaces/storeState";
import entitiesReducer from "store/entities/reducer";
import featuresReducers from "store/features/features-reducer";
import requestsReducer from "store/requests/reducer";
import viewsReducer from "store/views/views-reducer";

import referrerPathname from "./referrer-pathname";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default (history: History) =>
  combineReducers<IStoreState>({
    router: connectRouter(history),
    // @ts-expect-error TS(2322)
    referrerPathname,
    // @ts-expect-error TS(2322)
    views: viewsReducer,
    // @ts-expect-error TS(2322)
    entities: entitiesReducer,
    // @ts-expect-error TS(2322)
    features: featuresReducers,
    // @ts-expect-error TS(2322)
    requests: requestsReducer,
  });
